import React, { useEffect } from 'react';
import { Box, Container, Typography, Paper, Grid, Button, Card, CardContent, CardActions } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom'; // Import RouterLink
import PublicPageTheme from '../components/PublicPageTheme';
import { useOrg } from '../context/OrgContext';

const LearnMore = () => {
  const { name } = useOrg();
  useEffect(() => {
    document.title = `Partner With Us — ${name}`;
    return () => { document.title = name; };
  }, [name]);

  return (
    <PublicPageTheme>
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 4 }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Discover the {name} Advantage
          </Typography>
          <Typography variant="h6" color="text.secondary" paragraph>
            Join a network dedicated to excellence, reliability, and partnership.
          </Typography>
        </Paper>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'secondary.main' }}>
                  Why Partner with {name}?
                </Typography>
                <Typography paragraph>
                  At {name}, we believe in building strong, mutually beneficial relationships with our service providers. We understand the challenges you face and are committed to providing the support and resources you need to succeed.
                </Typography>
                <Typography paragraph>
                  Our state-of-the-art digital platform streamlines dispatching, communication, and payment processes, allowing you to focus on what you do best – providing exceptional roadside assistance.
                </Typography>
                <Typography paragraph>
                  We offer competitive rates, prompt payments, and access to a steady stream of service requests from our extensive customer base.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={2} sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'secondary.main' }}>
                  Our Commitment to You
                </Typography>
                <ul>
                  <li><Typography>Fair and transparent compensation.</Typography></li>
                  <li><Typography>Advanced technology for efficient operations.</Typography></li>
                  <li><Typography>Dedicated support team available 24/7.</Typography></li>
                  <li><Typography>Opportunities for growth and increased volume.</Typography></li>
                  <li><Typography>A true partnership focused on shared success.</Typography></li>
                </ul>
                <Typography paragraph sx={{ mt: 2 }}>
                  We value the expertise and dedication of our service providers and strive to be the motor club partner of choice.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card elevation={2} sx={{ textAlign: 'center' }}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom>
                  Ready to Join Our Network?
                </Typography>
                <Typography paragraph>
                  Take the next step towards a rewarding partnership. Apply today and become part of the {name} family.
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  component={RouterLink} // Use RouterLink for navigation
                  to="/applicationform"      // Link back to the application form page
                  sx={{ mt: 2 }}
                >
                  Apply Now
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
    </PublicPageTheme>
  );
};

export default LearnMore;